export const orderStatusActionTypes = {
    ORDER_STATUS_RECEIVED: 'ORDER_STATUS_RECEIVED'
};


// WEBPACK FOOTER //
// ./src/orderStatus/reducers/order-status-action-types.js